import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const ReferenceSection = ({ number, formData, handleChange, prefix }) => (
  <div className="bg-gray-50 p-6 rounded-lg space-y-4">
    <h4 className="font-bold text-lg">Professional Reference {number}</h4>
    
    <div>
      <Label htmlFor={`${prefix}_name`}>Full Name</Label>
      <Input
        id={`${prefix}_name`}
        value={formData[`${prefix}_name`]}
        onChange={(e) => handleChange(`${prefix}_name`, e.target.value)}
      />
    </div>

    <div>
      <Label htmlFor={`${prefix}_address`}>Street Address</Label>
      <Input
        id={`${prefix}_address`}
        value={formData[`${prefix}_address`]}
        onChange={(e) => handleChange(`${prefix}_address`, e.target.value)}
      />
    </div>

    <div className="grid md:grid-cols-3 gap-4">
      <div>
        <Label htmlFor={`${prefix}_city`}>City</Label>
        <Input
          id={`${prefix}_city`}
          value={formData[`${prefix}_city`]}
          onChange={(e) => handleChange(`${prefix}_city`, e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor={`${prefix}_state`}>State</Label>
        <Input
          id={`${prefix}_state`}
          value={formData[`${prefix}_state`]}
          onChange={(e) => handleChange(`${prefix}_state`, e.target.value)}
          placeholder="PA"
        />
      </div>
      <div>
        <Label htmlFor={`${prefix}_zip`}>ZIP Code</Label>
        <Input
          id={`${prefix}_zip`}
          value={formData[`${prefix}_zip`]}
          onChange={(e) => handleChange(`${prefix}_zip`, e.target.value)}
        />
      </div>
    </div>

    <div className="grid md:grid-cols-2 gap-4">
      <div>
        <Label htmlFor={`${prefix}_email`}>Email Address</Label>
        <Input
          id={`${prefix}_email`}
          type="email"
          value={formData[`${prefix}_email`]}
          onChange={(e) => handleChange(`${prefix}_email`, e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor={`${prefix}_phone`}>Telephone Number</Label>
        <Input
          id={`${prefix}_phone`}
          type="tel"
          value={formData[`${prefix}_phone`]}
          onChange={(e) => handleChange(`${prefix}_phone`, e.target.value)}
        />
      </div>
    </div>
  </div>
);

const Step8References = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Professional References</h3>
        <p className="text-gray-600">Please provide professional references (optional)</p>
      </div>

      <ReferenceSection number={1} formData={formData} handleChange={handleChange} prefix="ref1" />
      <ReferenceSection number={2} formData={formData} handleChange={handleChange} prefix="ref2" />
      <ReferenceSection number={3} formData={formData} handleChange={handleChange} prefix="ref3" />
    </div>
  );
};

export default Step8References;